import { render, staticRenderFns } from "./service-leg-select.vue?vue&type=template&id=53547db2"
import script from "./service-leg-select.vue?vue&type=script&lang=js"
export * from "./service-leg-select.vue?vue&type=script&lang=js"
import style0 from "./service-leg-select.vue?vue&type=style&index=0&id=53547db2&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports